import { Platform } from 'react-native';
import {
  buildLegacyCvShareUrl,
  buildPersonPrivateCvShareUrl,
} from '@tabbio/utils/public-url';

const DEFAULT_APP_URL = 'https://app.tabbio.com';

export function buildCvShareUrl(
  token: string,
  fallbackUrl?: string | null,
  ownerHandle?: string | null,
) {
  if (fallbackUrl) return fallbackUrl;
  if (ownerHandle) {
    return buildPersonPrivateCvShareUrl(ownerHandle, token);
  }
  return buildLegacyCvShareUrl(token, DEFAULT_APP_URL);
}

export function buildCvAccessInviteUrl(
  token: string,
  fallbackUrl?: string | null,
) {
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return new URL(`/cv-access/${encodeURIComponent(token)}`, window.location.origin)
      .toString();
  }
  if (fallbackUrl) return fallbackUrl;
  return new URL(`/cv-access/${encodeURIComponent(token)}`, DEFAULT_APP_URL)
    .toString();
}
